const DEVICE_DAMAGES = [
  'Cracked/Broken Screen',
  'Microphone Issues',
  'Speaker Issues',
  'Headphone Jack Issues',
  'Port Issue',
  'Accidental Drop Damage',
  'Liquid/Spill Damage',
  'Other',
];

export default DEVICE_DAMAGES;
